<template>
  <div class="rebate-monitor">
    <div class="list-hd">
      <el-form :inline="true" :model="searchValue" class="demo-form-inline">
        <el-form-item label="用户ID:">
          <el-input
            v-model="searchValue.user_id"
            clearable
            placeholder="请输入用户ID"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户名:">
          <el-input
            v-model="searchValue.username"
            clearable
            placeholder="请输入用户名"
          ></el-input>
        </el-form-item>
        <el-form-item label="返利标记:">
          <el-select
            v-model="searchValue.is_rebate"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in rebateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-for="filter in anomalyFilters"
          :key="filter.key"
          :label="filter.label + ':'"
        >
          <el-select
            v-model="searchValue[filter.key]"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in anomalyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchList">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="exportList">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            plain
            :loading="phoneChangeBatchValue !== null"
            :disabled="phoneChangeSubmitting"
            @click="openBatchChangePhoneDialog"
          >批量设置手机号改绑</el-button>
          <span v-if="selectedPhoneChangeUsers.length" class="phone-change-selection-count">
            已选 {{ selectedPhoneChangeUsers.length }} 个用户
          </span>
        </el-form-item>
      </el-form>
    </div>

    <div class="report-help-bar">
      <el-popover
        placement="right-start"
        :width="640"
        trigger="hover"
        :open-delay="150"
        popper-class="rebate-report-help-popper"
      >
        <div class="rebate-report-help-content">
          <div class="rebate-report-help-notice">
            该功能报表目前只统计和预警 新游戏：石器新游（部落远征）的数据
          </div>

          <section class="rebate-report-help-section">
            <h4>一、返利用户充值情况数据报表</h4>
            <p>
              运营后台增加返利标记功能，允许将对应账号标记为返利用户，便于第二点的监控；并增加返利用户充值情况数据报表：
            </p>
            <ol>
              <li>累计充值天数：历史至昨天</li>
              <li>累计充值金额：历史至昨天</li>
              <li>昨日充值金额：昨天</li>
              <li>累计停充天数：最后一笔充值时间至昨天</li>
              <li>
                停充期间为在线（白嫖）还是离线（弃坑）
                <span class="rebate-report-help-note">
                  备注：最近3天未登录算离线，最近3天未充值算停充
                </span>
              </li>
            </ol>
          </section>

          <section class="rebate-report-help-section">
            <h4>二、返利账号钉钉预警</h4>
            <p>返利用户的 IP 和设备使用占比异常预警（IP、设备异常；充值异常）：</p>
            <ol>
              <li>
                设备判断：同时满足常用设备占比大于90%、登录设备小于3个的标记正常，否则为异常；多个返利账号存在相同使用设备的，也标记为异常。
                <span class="rebate-report-help-note">
                  注：常用设备定义：原号主转游的，以新游（部落远征）注册设备为准。
                </span>
              </li>
              <li>
                登录 IP 判断：登录 IP 不为跨省 IP 的标记正常，否则为异常；多个返利账号存在相同使用 IP 的，也标记为异常。
              </li>
            </ol>
          </section>
        </div>

        <span
          slot="reference"
          class="report-help-trigger"
          role="button"
          tabindex="0"
        >
          <i class="el-icon-info"></i>
          功能说明
        </span>
      </el-popover>
    </div>

    <el-dialog
      title="批量设置手机号改绑"
      :visible.sync="batchPhoneChangeDialogVisible"
      :close-on-click-modal="false"
      append-to-body
      width="460px"
    >
      <p>已选择 {{ selectedPhoneChangeUsers.length }} 个用户</p>
      <el-form label-width="100px">
        <el-form-item label="改绑设置:">
          <el-radio-group v-model="batchPhoneChangeChoice">
            <el-radio :label="0">允许改绑</el-radio>
            <el-radio :label="1">禁止改绑</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          :disabled="phoneChangeSubmitting || phoneChangeConfirming"
          @click="batchPhoneChangeDialogVisible = false"
        >取消</el-button>
        <el-button
          type="primary"
          :loading="phoneChangeBatchValue !== null"
          :disabled="phoneChangeConfirming"
          @click="confirmBatchChangePhone"
        >确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="修改返利用户信息"
      :visible.sync="editDialogVisible"
      :close-on-click-modal="false"
      append-to-body
      width="520px"
    >
      <el-form :model="editForm" label-width="100px">
        <el-form-item label="用户ID:">
          <el-input v-model="editForm.user_id" disabled></el-input>
        </el-form-item>
        <el-form-item label="注册IP:">
          <el-input
            v-model="editForm.register_ip"
            clearable
            placeholder="请输入注册IP"
          ></el-input>
        </el-form-item>
        <el-form-item label="注册设备:">
          <el-input
            v-model="editForm.register_gdid"
            clearable
            placeholder="请输入注册设备GDID"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色ID:">
          <el-input
            v-model="editForm.role_id"
            clearable
            placeholder="请输入角色ID"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="editSubmitting"
          @click="submitRegisterInfo"
        >
          确定
        </el-button>
      </div>
    </el-dialog>

    <el-table
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      row-key="user_id"
      :max-height="tableHeight"
      stripe
      border
      style="width: 100%"
      @selection-change="handlePhoneChangeSelection"
    >
      <el-table-column
        type="selection"
        width="55"
        fixed="left"
        reserve-selection
        :selectable="canSelectPhoneChangeUser"
      ></el-table-column>
      <el-table-column prop="user_id" label="用户ID" width="110"></el-table-column>
      <el-table-column prop="username" label="用户名" width="140"></el-table-column>
      <el-table-column prop="role_name" label="角色名称" width="140"></el-table-column>
      <el-table-column prop="role_id" label="角色ID" width="120"></el-table-column>
      <el-table-column label="返利标记" width="100">
        <template slot-scope="scope">
          <span class="rebate-status-content">
            <span>{{ formatRebate(scope.row.is_rebate) }}</span>
            <el-tooltip
              v-if="Number(scope.row.is_rebate) === 0"
              effect="dark"
              content="标记过被取消了，不再统计和预警，重新标记可恢复"
              placement="top"
            >
              <i
                class="el-icon-warning-outline rebate-cancelled-tip"
                tabindex="0"
              ></i>
            </el-tooltip>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="total_recharge_days"
        label="累计充值天数"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="total_recharge_amount"
        label="累计充值金额"
        width="130"
      ></el-table-column>
      <el-table-column
        prop="yesterday_recharge_amount"
        label="昨日充值金额"
        width="130"
      ></el-table-column>
      <el-table-column
        prop="stop_recharge_days"
        label="累计停充天数"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="stop_recharge_status_text"
        label="停充期间状态"
        min-width="130"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="device_anomaly_text"
        label="设备异常"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="device_anomaly_desc"
        label="设备异常描述"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="ip_anomaly_text"
        label="IP异常"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="ip_anomaly_desc"
        label="IP异常描述"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="shared_device_anomaly_text"
        label="共用设备异常"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="shared_device_desc"
        label="共用设备描述"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="shared_ip_anomaly_text"
        label="共用IP异常"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="shared_ip_desc"
        label="共用IP描述"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="last_recharge_date"
        label="最后充值日期"
        width="170"
      ></el-table-column>
      <el-table-column
        prop="analyzed_at"
        label="最后分析时间"
        width="170"
      ></el-table-column>
      <el-table-column label="操作" width="240" fixed="right">
        <template slot-scope="scope">
          <div class="rebate-row-actions">
            <el-button
              type="primary"
              size="mini"
              plain
              @click="openEditDialog(scope.row)"
            >
              修改
            </el-button>
            <el-button
              type="primary"
              size="mini"
              plain
              :loading="phoneChangeUserIds.indexOf(String(scope.row.user_id)) !== -1"
              :disabled="phoneChangeSubmitting"
              @click="confirmSingleChangePhone(scope.row)"
            >
              {{ isPhoneChangeForbidden(scope.row) ? '允许改绑手机号' : '禁止改绑手机号' }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        :total="totalRecords"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { urlSplicing } from "@/assets/js/public.js";

export default {
  name: "rebateMonitor",
  data() {
    return {
      loadingData: false,
      searchValue: {
        user_id: "",
        username: "",
        is_rebate: "",
        device_anomaly: "",
        ip_anomaly: "",
        shared_device_anomaly: "",
        shared_ip_anomaly: "",
      },
      historyValue: {},
      rebateOptions: [
        { value: 1, label: "是" },
        { value: 0, label: "否" },
      ],
      anomalyOptions: [
        { value: 1, label: "异常" },
        { value: 0, label: "正常" },
      ],
      anomalyFilters: [
        { key: "device_anomaly", label: "设备异常" },
        { key: "ip_anomaly", label: "IP异常" },
        { key: "shared_device_anomaly", label: "共用设备异常" },
        { key: "shared_ip_anomaly", label: "共用IP异常" },
      ],
      tableData: [],
      tableHeight: 0,
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      selectedPhoneChangeUsers: [],
      phoneChangeConfirming: false,
      phoneChangeSubmitting: false,
      phoneChangeUserIds: [],
      phoneChangeBatchValue: null,
      batchPhoneChangeDialogVisible: false,
      batchPhoneChangeChoice: 0,
      editDialogVisible: false,
      editSubmitting: false,
      editForm: {
        user_id: "",
        register_ip: "",
        register_gdid: "",
        role_id: "",
      },
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.getList(true);
  },
  beforeMount() {
    this.tableHeight = document.documentElement.clientHeight - 260;
  },
  methods: {
    handlePhoneChangeSelection(selection) {
      this.selectedPhoneChangeUsers = selection;
    },
    canSelectPhoneChangeUser() {
      return !this.phoneChangeSubmitting;
    },
    clearPhoneChangeSelection() {
      this.selectedPhoneChangeUsers = [];
      if (this.$refs.table) {
        this.$refs.table.clearSelection();
      }
    },
    isPhoneChangeForbidden(row) {
      return Number(row.is_forbidden_change_phone) === 1;
    },
    openBatchChangePhoneDialog() {
      if (this.phoneChangeConfirming || this.phoneChangeSubmitting) return;
      if (!this.selectedPhoneChangeUsers.length) {
        this.$message.warning("请先勾选需要操作的用户");
        return;
      }
      this.batchPhoneChangeChoice = 0;
      this.batchPhoneChangeDialogVisible = true;
    },
    async confirmBatchChangePhone() {
      if (this.batchPhoneChangeChoice !== 0 && this.batchPhoneChangeChoice !== 1) {
        this.$message.warning("请选择允许改绑或禁止改绑");
        return;
      }
      const success = await this.confirmChangePhone(
        this.selectedPhoneChangeUsers,
        this.batchPhoneChangeChoice,
        true
      );
      if (success) {
        this.batchPhoneChangeDialogVisible = false;
      }
    },
    confirmSingleChangePhone(row) {
      this.confirmChangePhone([row], this.isPhoneChangeForbidden(row) ? 0 : 1, false);
    },
    async confirmChangePhone(rows, isForbidden, isBatch) {
      if (this.phoneChangeConfirming || this.phoneChangeSubmitting) return;

      const userIds = rows.map((row) => String(row.user_id));
      const action = isForbidden === 1 ? "禁止改绑手机号" : "允许改绑手机号";
      const target = isBatch
        ? `选中的 ${userIds.length} 个用户`
        : `用户 ${userIds[0]}`;

      this.phoneChangeConfirming = true;
      try {
        await this.$confirm(`确定将${target}设置为${action}吗？`, "操作确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
      } catch (error) {
        return;
      } finally {
        this.phoneChangeConfirming = false;
      }

      this.phoneChangeSubmitting = true;
      this.phoneChangeUserIds = userIds;
      this.phoneChangeBatchValue = isBatch ? isForbidden : null;
      try {
        const res = await fetch({
          url: "/admin/rebate_monitor/toggle_forbidden_change_phone",
          method: "POST",
          data: {
            user_ids: userIds.join(","),
            is_forbidden_change_phone: isForbidden,
          },
        });
        if (!res) return;
        if (!res.data.status) {
          this.$message.error(res.data.message || "设置失败");
          return;
        }

        this.tableData.concat(this.selectedPhoneChangeUsers).forEach((row) => {
          if (userIds.indexOf(String(row.user_id)) !== -1) {
            this.$set(row, "is_forbidden_change_phone", isForbidden);
          }
        });
        if (isBatch) {
          this.clearPhoneChangeSelection();
        }
        this.$message.success(res.data.message || `${action}设置成功`);
        return true;
      } catch (error) {
        this.$message.error("设置失败，请稍后重试");
      } finally {
        this.phoneChangeSubmitting = false;
        this.phoneChangeUserIds = [];
        this.phoneChangeBatchValue = null;
      }
    },
    buildSearchParams(values) {
      return Object.keys(values).reduce((params, key) => {
        const value = values[key];
        if (value !== "" && value !== null && value !== undefined) {
          params[key] = value;
        }
        return params;
      }, {});
    },
    formatRebate(value) {
      if (Number(value) === 1) return "是";
      if (Number(value) === 0 || Number(value) === 2) return "否";
      return "-";
    },
    openEditDialog(row) {
      this.editForm = {
        user_id: row.user_id,
        register_ip: row.register_ip || "",
        register_gdid: row.register_gdid || "",
        role_id:
          row.role_id === null || row.role_id === undefined
            ? ""
            : String(row.role_id),
      };
      this.editDialogVisible = true;
    },
    submitRegisterInfo() {
      const data = {
        user_id: this.editForm.user_id,
      };
      ["register_ip", "register_gdid", "role_id"].forEach((key) => {
        const value = String(this.editForm[key] || "").trim();
        if (value !== "") {
          data[key] = value;
        }
      });

      if (Object.keys(data).length === 1) {
        this.$message.warning("请至少填写一项需要修改的信息");
        return;
      }

      this.editSubmitting = true;
      fetch({
        url: "/admin/rebate_monitor/update_register_info",
        method: "POST",
        data,
      })
        .then((res) => {
          if (!res.data.status) {
            this.$message.error(res.data.message || "修改失败");
            return;
          }

          this.$message.success(res.data.message || "修改成功");
          this.editDialogVisible = false;
          this.getList(false);
        })
        .finally(() => {
          this.editSubmitting = false;
        });
    },
    handleSizeChange(value) {
      this.pageSize = value;
      this.currentPage = 1;
      this.getList(false);
    },
    handleCurrentChange(value) {
      this.currentPage = value;
      this.getList(false);
    },
    searchList() {
      this.clearPhoneChangeSelection();
      this.currentPage = 1;
      this.getList(true);
    },
    getList(reload = false) {
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
      }

      this.loadingData = true;
      fetch({
        url: "/admin/rebate_monitor/list",
        method: "GET",
        params: {
          ...this.buildSearchParams(this.historyValue),
          page: this.currentPage,
          per_page: this.pageSize,
        },
      })
        .then((res) => {
          if (!res.data.status) {
            this.$message.error(res.data.message || "列表加载失败");
            return;
          }

          const data = res.data.data || {};
          if (Array.isArray(data)) {
            this.tableData = data;
            this.totalRecords = data.length;
            return;
          }

          this.tableData = data.data || [];
          this.totalRecords = Number(data.total || 0);
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    exportList() {
      const params = {
        ...this.buildSearchParams(this.historyValue),
        export: 1,
        token: sessionStorage.getItem("access_token"),
      };
      urlSplicing(this.host + "admin/rebate_monitor/list", params);
    },
  },
};
</script>

<style lang="less" scoped>
.list-hd {
  margin-bottom: 8px;
}

.demo-form-inline {
  .el-input,
  .el-select {
    width: 210px;
  }
}

.pagination {
  padding-bottom: 20px;
  margin-top: 20px;
  text-align: right;
}

.phone-change-selection-count {
  margin-left: 12px;
  color: #606266;
  font-size: 13px;
}

.rebate-row-actions {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.report-help-bar {
  margin-bottom: 12px;
}

.report-help-trigger {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-height: 28px;
  padding: 0 10px;
  color: #409eff;
  font-size: 13px;
  line-height: 28px;
  background: #ecf5ff;
  border: 1px solid #d9ecff;
  border-radius: 4px;
  cursor: help;
  user-select: none;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.report-help-trigger:hover,
.report-help-trigger:focus {
  background: #e1f0ff;
  border-color: #b3d8ff;
  outline: none;
}

.report-help-trigger:focus-visible {
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.25);
}

.rebate-status-content {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  line-height: 1;
}

.rebate-cancelled-tip {
  color: #909399;
  font-size: 15px;
  line-height: 1;
  cursor: help;
}
</style>

<style lang="less">
.rebate-report-help-popper {
  padding: 18px 20px;
}

.rebate-report-help-content {
  color: #606266;
  font-size: 14px;
  line-height: 1.75;
}

.rebate-report-help-notice {
  padding: 10px 12px;
  color: #e6a23c;
  font-weight: 600;
  background: #fdf6ec;
  border-left: 3px solid #e6a23c;
  border-radius: 3px;
}

.rebate-report-help-section {
  margin-top: 16px;

  h4 {
    margin: 0 0 6px;
    color: #303133;
    font-size: 15px;
    font-weight: 600;
  }

  p {
    margin: 0 0 6px;
  }

  ol {
    padding-left: 22px;
    margin: 0;
  }

  li + li {
    margin-top: 4px;
  }
}

.rebate-report-help-note {
  display: block;
  margin-top: 2px;
  color: #909399;
  font-size: 13px;
}
</style>
